const currentYear = new Date().getFullYear();

export const enCustomMessages = {
    oui: 'Yes',
    non: 'No',
    action_annuler: 'Annuler',
    action_sauver: 'Sauver',
    //------------------------------------------------------------------------------------------------------------------
    // Menu
    //------------------------------------------------------------------------------------------------------------------
    fichier: 'File',
    ouvrir: 'Open',
    sauver: 'Save',
    exportPDF: 'PDF Export',
    //------------------------------------------------------------------------------------------------------------------
    menu: 'Menu',
    lectureMenu: 'Read mode',
    editMenu: 'Edition mode',
    reorderingMenu: 'Reordering mode',
    //------------------------------------------------------------------------------------------------------------------
    libelleMenu: "Label",
    //------------------------------------------------------------------------------------------------------------------
    // Confirmation delete
    //------------------------------------------------------------------------------------------------------------------
    confirmation_delete_titre: "Confirmation de suppression",
    confirmation_delete_question: "Êtes-vous sûr de vouloir supprimer « {VAR} » ?",
    confirmation_delete_enfant: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} element.",
    confirmation_delete_enfants: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} elements.",
    //------------------------------------------------------------------------------------------------------------------
    // Icon
    //------------------------------------------------------------------------------------------------------------------
    icon_titre: "Sélection de l'icône",
    icon_msg_pour: "Ceci changera l'icône pour « {VAR} ».",
    //------------------------------------------------------------------------------------------------------------------
    // Settings
    //------------------------------------------------------------------------------------------------------------------
    parametres: 'Settings',
    choixCouleur: 'Choose a color :',
    //------------------------------------------------------------------------------------------------------------------
    greeting: "Hi, Maria!",
    welcome: "Welcome back",
    search: "Search",
    aiAssistant: "AI Assistant",
    overview: "Overview",
    earnings: "Earnings",
    spendings: "Spendings",
    thanLastMonth: "than the last month",
    savings: "Savings",
    education: "Education",
    dreamHome: "Dream Home",
    car: "Car",
    holidays: "Holidays",
    healthcare: "Healthcare",
    budgetUtilization: "Budget Utilization",
    budgetUsed: "50% of budget used",
    totalBudget: "Total Budget",
    usedBudget: "Used Budget",
    transactions: "Transactions",
    pdfExport: "Export to PDF",
    excelExport: "Export to Excel",
    personalTransactions: "Personal Transactions",
    transactionDetails: "Transaction Details",
    merchant: "Merchant",
    orderStatus: "Order Status",
    time: "Time",
    customer: "Customer",
    email: "Email",
    paymentMethod: "Payment Method",
    transactionHash: "Transaction Hash",
    from: "From",
    to: "To",
    investments: "Investments",
    totalInvestments: "Total Investments",
    stocks: "Stocks",
    realEstates: "Real Estates",
    bonds: "Bonds",
    mutualFunds: "Mutual Funds",
    cryptocurrency: "Cryptocurrency",
    commodities: "Commodities",
    todayMovers: "Today's Top 5 Movers",
    stockChart: "Stock Chart",
    value: "Value",
    volume: "Volume",
    analytics: "Analytics",
    moneyCashflow: "Money Cashflow",
    year: "Year",
    month: "Month",
    settings: "Settings",
    personalInformation: "Personal Information",
    calendar: "Calendar",
    cardInformation: "Card Information",
    weather: "Weather",
    save: "Save",
    restore: "Restore",
    name: "Name",
    surname: "Surname",
    tag: "Tag",
    birthday: "Birthday",
    country: "Country",
    address: "Address",
    postCode: "Post Code",
    bank: "Bank",
    expirationDate: "Expiry Date",
    cardHolder: "Card Holder",
    cardNumber: "Card Number",
    partlyCloudy: "Partly Cloudy",
    humidity: "Humidity",
    dew: "Dew",
    pressure: "Pressure",
    windSpeed: "Wind Speed",
    footer: `Copyright © ${currentYear} Progress Software. All rights reserved.`,
    home: "Home",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    relatedTopics: "Related Topics",
    chatWithRoby: "Chat with Roby",
};

export const enComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty":
        "Drag a column header and drop it here to group by that column",
    "kendo.grid.noRecords": "No records available.",
    "kendo.grid.pagerFirstPage": "Go to the first page",
    "kendo.grid.pagerPreviousPage": "Go to the previous page",
    "kendo.grid.pagerNextPage": "Go to the next page",
    "kendo.grid.pagerLastPage": "Go to the last page",
    "kendo.grid.pagerPage": "Page",
    "kendo.grid.pagerOf": "of",
    "kendo.grid.pagerItems": "items",
    "kendo.grid.pagerItemsPerPage": "items per page",
    "kendo.grid.pagerPageNumberInputTitle": "Page Number",
    "kendo.grid.filter": "Filter",
    "kendo.grid.filterEqOperator": "Is equal to",
    "kendo.grid.filterNotEqOperator": "Is not equal to",
    "kendo.grid.filterIsNullOperator": "Is null",
    "kendo.grid.filterIsNotNullOperator": "Is not null",
    "kendo.grid.filterIsEmptyOperator": "Is empty",
    "kendo.grid.filterIsNotEmptyOperator": "Is not empty",
    "kendo.grid.filterStartsWithOperator": "Starts with",
    "kendo.grid.filterContainsOperator": "Contains",
    "kendo.grid.filterNotContainsOperator": "Does not contain",
    "kendo.grid.filterEndsWithOperator": "Ends with",
    "kendo.grid.filterGteOperator": "Is greater than or equal to",
    "kendo.grid.filterGtOperator": "Is greater than",
    "kendo.grid.filterLteOperator": "Is less than or equal to",
    "kendo.grid.filterLtOperator": "Is less than",
    "kendo.grid.filterIsTrue": "is true",
    "kendo.grid.filterIsFalse": "is false",
    "kendo.grid.filterBooleanAll": "(All)",
    "kendo.grid.filterAfterOrEqualOperator": "Is after or equal to",
    "kendo.grid.filterAfterOperator": "Is after",
    "kendo.grid.filterBeforeOperator": "Is before",
    "kendo.grid.filterBeforeOrEqualOperator": "Is before or equal to",
    "kendo.grid.filterFilterButton": "Filter",
    "kendo.grid.filterClearButton": "Clear",
    "kendo.grid.filterAndLogic": "And",
    "kendo.grid.filterOrLogic": "Or",
    "kendo.grid.filterDateToggle": "Toggle calendar",
    "kendo.grid.filterDateToday": "Today",
    "kendo.grid.filterNumericDecrement": "Decrease value",
    "kendo.grid.filterNumericIncrement": "Increase value",
    "kendo.grid.loading": "Loading",
    "kendo.grid.sort": "Sort",
    "kendo.grid.columnMenu": "Column Menu",
    "kendo.grid.columns": "Columns",
    "kendo.grid.lock": "Lock",
    "kendo.grid.unlock": "Unlock",
    "kendo.grid.stick": "Stick",
    "kendo.grid.unstick": "Unstick",
    "kendo.grid.setColumnPosition": "Set Column Position",
    "kendo.grid.sortAscending": "Sort Ascending",
    "kendo.grid.sortDescending": "Sort Descending",
    "kendo.grid.columnsApply": "Apply",
    "kendo.grid.columnsReset": "Reset",
    "kendo.grid.sortable": "Sortable",
    "kendo.grid.sortedAscending": "Sorted ascending",
    "kendo.grid.sortedDescending": "Sorted descending",
    "kendo.grid.sortedDefault": "Not sorted",

    // DropDowns
    "kendo.autocomplete.noDataText": "No data found",
    "kendo.autocomplete.clearTitle": "Clear",
    "kendo.combobox.noDataText": "No data found",
    "kendo.combobox.clearTitle": "Clear",
    "kendo.dropdownlist.noDataText": "No data found",
    "kendo.dropdownlist.clearTitle": "Clear",

    // Calendar
    "kendo.calendar.today": "TODAY",

    // TextBox
    "kendo.textbox.clearTitle": "Clear",

    // DatePicker
    "kendo.datepicker.today": "TODAY",
    "kendo.datepicker.toggle": "Toggle calendar",

    // DateInput
    "kendo.dateinput.increment": "Increase value",
    "kendo.dateinput.decrement": "Decrease value",

    // NumericTextBox
    "kendo.numerictextbox.increment": "Increase value",
    "kendo.numerictextbox.decrement": "Decrease value",

    // AIPrompt
    "kendo.aiprompt.generateOutput": "Generate",
    "kendo.aiprompt.copyOutput": "Copy",
    "kendo.aiprompt.retryGeneration": "Retry",
    "kendo.aiprompt.outputView": "Output",
    "kendo.aiprompt.promptView": "ASK AI",
    "kendo.aiprompt.promptPlaceholder": "How to...",
    "kendo.aiprompt.promptSuggestions": "Prompt Suggestions",
};